import React from "react";
import { connect } from "react-redux";
import { AlertCircle } from "lucide-react";
import FetchConfigurationSection from "./FetchConfigurationSection";
import { ConnectionTypes } from "./ConnectionTypeSection";

function AddDeviceStep2({ connectionType, mngtIpAddress }) {
    const isSsh = connectionType === ConnectionTypes.SSH;
    const isWinRm = connectionType === ConnectionTypes.WINRM;
    const ipString = typeof mngtIpAddress === "string" ? mngtIpAddress.trim() : "";
    const multiDeviceDisable = ipString.includes(",") || ipString.includes("-");

    return (
        <form className="oct_form oct_form-label-center pt-4 px-4 modal-v2-form modal-v2-form-step2" autoComplete="off">
            {/* <div className="oct_form-title modal-v2-title">
                Add Device Wizard - STEP 2: Connection Status and Configuration retrieval
            </div> */}

            {multiDeviceDisable && (
                <div className="oct_hint modal-v2-hint modal-v2-hint-warning modal-v2-step2-bulk-note">
                    <AlertCircle className="modal-v2-hint-icon" size={20} />
                    <div className="modal-v2-hint-copy">
                        <span className="modal-v2-hint-title">Bulk Device Import:</span>
                        <span className="modal-v2-hint-text">
                            Connection testing is disabled for bulk imports. Continue to the next step to configure the devices in batch.
                        </span>
                    </div>
                </div>
            )}

            <div className="modal-v2-step2-shell">
                {(isSsh || isWinRm) && (
                    <div className="modal-v2-step2-requirements-card">
                        <div className="modal-v2-step2-requirements-title">
                            {isSsh ? "SSH connection requirements" : "WinRM connection requirements"}
                        </div>

                        {isSsh ? (
                            <ul className="modal-v2-step2-requirements-list">
                                <li>The IP entry must be reachable from the Octopus server.</li>
                                <li>The SSH protocol must be enabled and supported by the device.</li>
                                <li>Firewall rules must allow the remote connection on the configured port.</li>
                            </ul>
                        ) : (
                            <>
                                <ul className="modal-v2-step2-requirements-list">
                                    <li>Basic authentication must be allowed.</li>
                                    <li>Unencrypted data transfer must be allowed.</li>
                                </ul>
                                <div className="modal-v2-step2-code-label">
                                    Run the following on the remote host:
                                </div>
                                <div className="modal-v2-step2-code-block">
                                    <div>&gt; winrm quickconfig</div>
                                    <div>{"> winrm set winrm/config/service/Auth '@{Basic=\"true\"}'"}</div>
                                    <div>{"> winrm set winrm/config/service '@{AllowUnencrypted=\"true\"}'"}</div>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {!multiDeviceDisable && (
                    <div className="modal-v2-step2-status-card">
                        <FetchConfigurationSection />
                    </div>
                )}
            </div>
        </form>
    );
}

function mapStateToProps(state) {
    return {
        connectionType: state.addDeviceModal.connectionType,
        mngtIpAddress: state.addDeviceModal.mngtIpAddress
    };
}

export default connect(mapStateToProps)(AddDeviceStep2);
